import { Box } from '@mui/material';
import React from 'react';
import { COLOR_MAP } from '../../constants/ColorNames';

type BarChartProps = {
  bars: number[];
  isSelectedCampaign?: boolean;
  isWhatsAppCampaign : boolean;
}

export const BarChart = (props: BarChartProps) => {
  const { bars, isSelectedCampaign, isWhatsAppCampaign } = props;

  if (!bars || !bars.length) return null;


  const isAllValuesZero = bars.every(item => item === 0);

  const updatedBars = isAllValuesZero ? Array(bars.length).fill(2) : bars;


  const maxValue = Math.max(...updatedBars);

  const ratioMultiplier = isAllValuesZero ? 1 : 90 / maxValue;

  const gradientMap: any = {
    0: 'linear-gradient(180deg, rgba(226, 204, 242, 0.38) 0.17%, #E2CCF2 75.27%)',
    1: 'linear-gradient(180deg, rgba(197, 153, 229, 0.38) 0.17%, #C599E5 75.27%)',
    2: 'linear-gradient(180deg, rgba(168, 102, 216, 0.38) 0.17%, rgba(168, 102, 216, 0.94) 75.27%)',
    3: 'linear-gradient(180deg, rgba(139, 51, 203, 0.38) 0.17%, rgba(139, 51, 203, 0.94) 75.27%)',
    4: 'linear-gradient(180deg, rgba(88, 0, 152, 0.38) 0%, rgba(88, 0, 152, 0.94) 96.9%);',
  }

  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', width: '400px', background: isSelectedCampaign? '#FDF9FF':'#FAFBFC', borderRadius: '0 0  4px 4px' }}>
      { updatedBars.map((item, index) => {
        const isLast =  updatedBars.length - 1 === index;
        const isFirst = index === 0;
        const graphHeight = item * ratioMultiplier;
        const nextItemHeight =  updatedBars[index + 1] * ratioMultiplier;
        const graphConnectorHeight = !isLast ? Math.max(graphHeight, nextItemHeight) : 0;
        const graphDiffrence = graphHeight - nextItemHeight;

        const clipPathValue = graphDiffrence < 0 ? `polygon(0 ${Math.abs(graphDiffrence)}px, 100% 0%, 100% 100%, 0% 100%)` : `polygon(0 0, 100% ${Math.abs(graphDiffrence)}px, 100% 100%, 0% 100%)`

        return (
          <Box display="flex" alignItems="flex-end">
            <Box sx={{
              width: isWhatsAppCampaign ? '82px' : '64px',
              height: `${graphHeight}px`,
              background: gradientMap[index]
            }}></Box>
            {!isLast &&
              <>
                <Box sx={{
                  clipPath: clipPathValue,
                  height: `${graphConnectorHeight}px`,
                  width: '16px',
                  backgroundColor: COLOR_MAP.PILL_BORDER,
                }}>
                </Box>
                <Box sx={{
                  borderRight: `0.5px dashed ${COLOR_MAP.GREY_5}`,
                  height: maxValue * 90 / maxValue,
                }}></Box>
              </>
            }
          </Box>
        )
      })
      }
    </div>
  )
}
